import { createReducer } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/es/storage';

import { authSessionEnd } from '@/modules/auth/services/actions';

import { StaticModal } from '../constants';
import { setModalVisibility } from './actions';

const initialState: Record<
    string,
    {
        visibility: boolean;
        data?: {};
    }
> = {};

export const modals = createReducer(initialState, builder => {
    builder.addCase(setModalVisibility, (state, action) => {
        state[action.meta.modal] = action.payload;
    });
    builder.addCase(authSessionEnd, state => {
        delete state[StaticModal.USER_FEEDBACK];
    });
});

export const reducer = persistReducer(
    {
        key: 'modals',
        storage,
        whitelist: [StaticModal.USER_FEEDBACK],
        version: 0,
    },
    modals,
);
